import url from './url';
import request from './request';

const { REACT_APP_ENV: APP_ENV } = process.env;

const getHeaders = () => ({
  'Cache-Control': 'no-cache',
});

export const getFeatureFlags = (userEmail) => {
  const params = new URLSearchParams({
    environment: 'default',
    appName: APP_ENV,
    userId: userEmail,
  });

  return request(`${url.featureFlags}?${params.toString()}`, {
    headers: getHeaders(),
  });
};
